import React from "react"
import styled from "styled-components"
import { breakpoints } from "../../../theme"

const Cartouche = ({ children }) => {
  return <Wrapper>{children}</Wrapper>
}

const Wrapper = styled.div`
  position: relative;
  background-color: var(--neutral-background);
  padding: 20px 30px;
  display: grid;
  grid-gap: 40px;
  overflow: hidden;
  line-height: 1.3;

  @media (min-width: ${breakpoints.medium}px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: ${breakpoints.large}px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  > * {
    align-self: start;
    width: 100%;
  }

  > * + * {
    &:before {
      position: absolute;
      content: "";
      display: block;
      background-color: rgba(255, 255, 255, 0.4);
      height: 2px;
      right: 10px;
      left: 10px;
      transform: translateY(-22px);

      @media (min-width: ${breakpoints.large}px) {
        top: 10px;
        bottom: 10px;
        right: unset;
        left: unset;
        width: 2px;
        height: unset;
        transform: translateX(-21px);
      }
    }
  }

  a {
    text-decoration: none;
    color: currentColor;
  }
`

export { Cartouche }
